export class Authenticator {
}
//# sourceMappingURL=authenticator.js.map